/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import '../../../css/ctfResource.css';
import { SearchOutlined, UploadOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Table, Input, Modal, Row, Col, Upload, Progress, Pagination, Divider, Dropdown, Menu } from 'antd'
import instance from '../../Communal/instance';
import { Alert } from '../../Communal/utility';
import DeteleBox from '../deteleBox';
import $ from 'jquery';
import Comfirm from '../comfirm';
import ExportModal from '../export';
const { Column } = Table;
const option_type_text = { 1: '单选', 2: '多选', 3: '判断', 4: '填空' };
function List() {
    const [search, setsSearch] = useState({
        show: false,
        value: ""
    });
    const [initData, setInitData] = useState(
        {
            data: [],
            allCount: 0,
            hotKeyword: [],
            resourceNumber: {}
        }
    );
    const [filter, setFilter] = useState(
        {
            page: 1,
            size: 10,
            search: "",
            classify: [],
            status: [],
            username: "",
            option_type: ""
        }
    );
    const [classify, setClassify] = useState([]);
    const [checkList, setCheckList] = useState([]);
    const [userType, setUserType] = useState(0);
    const [userIssue, setIssue] = useState(false);
    const [deleteTip, setDeteleTip] = useState(
        {
            show: false,
            list: []
        }
    );
    const [comfirmShow, setComfirmShow] = useState({
        visible: false,
        mode: 'test',
        issue: '',
    })
    const [visible, setVisible] = useState(false);
    const [percent, setPercent] = useState(0);
    const [isUpload, setIsUpload] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [exportShow, setExportShow] = useState(false)
    let handleTableChange = (pagination, filters, sorter) => {
        if (filters.classify) {
            filter.classify = filters.classify;
        } else {
            filter.classify = [];
        }
        if (filters.option_type) {
            filter.option_type = filters.option_type;
        } else {
            filter.option_type = "";
        }
        if (filters.issue) {
            filter.issue = filters.issue;
        } else {
            filter.issue = [];
        }
        if (filters.status) {
            filter.status = filters.status;
        } else {
            filter.status = [];
        }
        filter.page = 1;
        setFilter({ ...filter });
    }
    let handelSearch = () => {
        if (search.value !== filter.search) {
            filter.search = search.value;
            filter.page = 1;
            setFilter({ ...filter })
        }
        search.show = true;
        setsSearch({ ...search });
    }
    let onClicks = (ev) => {
        var e = ev || window.event; //浏览器兼容性
        var elem = e.target || e.srcElement;
        while (elem) {
            //循环判断至跟节点，防止点击的是div子元素
            if (elem.className === "top") {
                return;
            } else {
                elem = elem.parentNode;
            }
        }
        search.show = false;
        setsSearch({ ...search });
    }
    useEffect(() => {
        instance.get("/ctf/classify/?type=5").then(data => {
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    data[i].text = data[i].name;
                    data[i].value = data[i].id
                }
            }
            setClassify(data)
        })
        instance.get("/ctf/user/type/?mode=test").then(data => {
            setUserType(data.user_type);
            setIssue(data.issue);
        })
    }, [])
    useEffect(() => {
        getTest()
    }, [filter]);
    //获取热搜词
    useEffect(() => {
        instance.get("/ctf/hot_word/", { params: { type: "test", size: 5 } }).then(data => {
            initData.hotKeyword = data;
            setInitData({ ...initData })
        })
    }, [])
    //获取资源数
    useEffect(() => {
        resourceNumber();
    }, [])
    let resourceNumber = () => {
        instance.get("/ctf/sum/", { params: { type: "test" } }).then(data => {
            initData.resourceNumber = data;
            setInitData({ ...initData })
        })
    }
    //获取工具列表
    let getTest = () => {
        if (filter.option_type === '') {
            delete filter.option_type
        }
        instance.get("/test/", { params: filter }).then(data => {
            initData.data = data.results;
            initData.allCount = data.count;
            setInitData({ ...initData })
        })
    }
    //单个删除或者批量删除操作
    let resourceDelete = (list) => {
        if (list.length === 0) {
            Alert("warn", "请选择需要删除的题目");
            return
        }
        instance.post("/test/delete/", { id: list }).then(data => {
            if (filter.page > 1 && (initData.data.length === list.length)) {
                filter.page -= 1;
                setFilter({ ...filter })
            } else {
                getTest();
            }
            Alert("success", "删除成功");
            setCheckList([]);
            deleteTip.list = [];
            deleteTip.show = false;
            setDeteleTip({ ...deleteTip })
            resourceNumber();
        })
    }
    //搜索回车事件
    let calAge = (e) => {
        var evt = window.event || e;
        if (evt.keyCode === 13) {
            handelSearch();
        }
    }
    const uploadProps = {
        fileList: fileList,
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([file]);
            return false
        },
    };
    //导入
    const onImportTest = () => {
        if (fileList.length === 0) {
            Alert('error', '请选择导入文件')
            return
        }
        let formData = new FormData();
        formData.append('file', fileList[0])
        $.ajax({
            url: `/test/import/`,
            type: 'POST',
            enctype: 'multipart/form-data',
            data: formData,
            // 告诉jQuery不要去处理发送的数据
            processData: false,
            // 告诉jQuery不要去设置Content-Type请求头
            contentType: false,
            timeout: 60000,//设置超时时间
            beforeSend: function () {
                setIsUpload(true);
                setUploadLoading(true);
            },
            xhr: function () {
                let myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', function (e) {
                        if (e.lengthComputable) {
                            let percent = Math.floor((e.loaded / e.total) * 100);
                            setPercent(percent);
                        }
                    }, false);
                    myXhr.upload.addEventListener('load', function (e) { }, false);
                }
                return myXhr;
            },
            success: function (res) {
                setUploadLoading(false);
                setIsUpload(false);
                setVisible(false);
                setFileList([])
                if (res.success_count > 0) {
                    getTest();
                }
                Alert('info', `导入成功${res.success_count}个，导入失败${res.error_count}个`);
                if (res.error_path !== "") {
                    let a = document.createElement('a');
                    a.download = 'test_error.xlsx';
                    a.href = res.error_path;
                    a.click();
                    a.remove();
                }
            },
            error: function (res) {
                if (res?.responseJSON?.file) {
                    Alert('error', res?.responseJSON?.file)
                }
                setIsUpload(false);
                setUploadLoading(false);
                setFileList([])
            }
        });
    }
    //导出
    const onExportTest = (type) => {
        //1全部导出 2批量导出
        let url = '/test/export/?type=' + type;
        if (type === '2') {
            checkList.forEach(x => {
                url = url + '&id=' + x
            })
        }
        let a = document.createElement('a');
        a.download = 'test_list';
        a.href = url;
        a.click();
        a.remove();
        setCheckList([])

    }
    const menu = (
        <Menu onClick={({ key }) => { changeStatus(key) }}>
            <Menu.Item key={1}>回收</Menu.Item>
            <Menu.Item key={2}>发布</Menu.Item>
        </Menu>
    );
    const changeStatus = (key) => {
        setComfirmShow({ ...comfirmShow, visible: true, issue: Number(key) });
    }
    const handleIssue = () => {
        setCheckList([]);
        setFilter({ ...filter });
    }
    return (
        <div className="ctf-resource-list test-resource-list" onClick={onClicks}>
            <div className="banner"></div>
            <div className="ctf-resource-search">
                <div className="top">
                    {
                        search.show ?
                            <div className="search-input">
                                <input
                                    className="input-fouce"
                                    type="text"
                                    placeholder="请输入关键字进行搜索"
                                    value={search.value}
                                    onKeyDown={(e) => calAge(e)}
                                    onChange={(e) => {
                                        search.value = e.target.value;
                                        setsSearch({ ...search })
                                    }}
                                />
                            </div>
                            : <div className="statistics">
                                <div>
                                    <span>{initData.resourceNumber.day}</span>
                                    <span>今日新增</span>
                                </div>
                                <div>
                                    <span>{initData.resourceNumber.month}</span>
                                    <span>本月新增</span>
                                </div>
                                <div>
                                    <span>{initData.resourceNumber.sum}</span>
                                    <span>总资源数</span>
                                </div>
                            </div>
                    }
                    <div className="search-btn" onClick={() => handelSearch()}>
                        <SearchOutlined />
                    </div>
                </div>
                <div className="bottom">
                    今天热点搜索：
                    {
                        initData.hotKeyword.map((val, key) => {
                            return <span key={"key" + key} onClick={() => {
                                filter.page = 1;
                                filter.search = val;
                                setFilter({ ...filter })
                            }}>{val}</span>
                        })
                    }
                    {
                        initData.hotKeyword.length === 0 &&
                        "暂无热搜关键字"
                    }
                </div>
            </div>
            <div className="ctf-resource-table content-container">
                <div className="handle">
                    {
                        userType > 1 ?
                            <div style={{ display: 'inline-block' }}>
                                <Button
                                    danger
                                    disabled={checkList.length === 0}
                                    onClick={() => {
                                        if (checkList.length > 0) {
                                            deleteTip.show = true;
                                            deleteTip.list = checkList;
                                            setDeteleTip({ ...deleteTip })
                                        } else {
                                            Alert("warn", "请选择需要删除的题目");
                                        }
                                    }}
                                >
                                    批量删除
                                </Button>
                                {
                                    userIssue ?
                                        <Dropdown
                                            overlay={menu}
                                            disabled={checkList.length === 0}
                                        >
                                            <Button type="primary" style={{ marginLeft: '12px' }}>批量修改发布状态<DownOutlined /></Button>
                                        </Dropdown> : undefined
                                }
                                <Button
                                    style={{ float: 'initial', marginLeft: '12px' }}
                                    disabled={checkList.length === 0}
                                    type="primary"
                                    onClick={() => { onExportTest('2') }}
                                >批量导出</Button>
                                <Button
                                    style={{ float: 'initial', marginLeft: '12px' }}
                                    type="primary"
                                    onClick={() => { onExportTest('1') }}
                                >全部导出</Button>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '10px' }}
                                    onClick={() => setExportShow(true)}
                                >
                                    可配置导出
                                </Button>
                            </div> : undefined
                    }
                    <Button
                        type="primary"
                        onClick={() => window.open("/#/activity/submittest/0/0/0")}
                    >提交题目</Button>
                    <Button
                        style={{ marginRight: '12px' }}
                        type="primary"
                        onClick={() => { setVisible(true) }}
                    >导入题目</Button>
                </div>
                <Table
                    dataSource={initData.data}
                    rowKey={record => record.id}
                    bordered
                    scroll={{ x: 1200 }}
                    pagination={false}
                    rowSelection={userType > 1 && {
                        type: "checkbox",
                        selectedRowKeys: checkList,
                        preserveSelectedRowKeys: true,
                        onChange: ((selectedRowKeys) => {
                            setCheckList(selectedRowKeys)
                        })
                    }}
                    onChange={handleTableChange}
                >
                    <Column
                        title="序号"
                        key="serial"
                        align="center"
                        width={80}
                        fixed='left'
                        render={(text, record, index) => {
                            return <span
                                className="click-href"
                                onClick={() => {
                                    window.location.href = "/#/activity/testdetail/0/" + record.id
                                }}
                            >
                                {filter.size * (filter.page - 1) + index + 1}
                            </span>
                        }}
                    />
                    <Column
                        title="题目编号"
                        key="number"
                        align="center"
                        dataIndex="number"
                        width={150}
                        fixed='left'
                        render={(text, record) => {
                            return text ? <span
                                className="click-href"
                                onClick={() => {
                                    window.location.href = "/#/activity/testdetail/0/" + record.id
                                }}
                            >
                                {text}
                            </span>
                                : "暂无编号"
                        }}
                    />
                    <Column
                        title="题目名称"
                        key="name"
                        align="center"
                        dataIndex="name"
                        width={250}
                        fixed='left'
                        render={(text, record) => {
                            return <a
                                className="click-href"
                                href={"/#/activity/testdetail/0/" + record.id}
                            >
                                {text}
                            </a>
                        }}
                    />
                    <Column
                        title="题目分类"
                        key="classify"
                        align="center"
                        dataIndex="classify"
                        filters={classify}
                        width={150}
                    />
                    <Column
                        title="题目类型"
                        key="option_type"
                        align="center"
                        dataIndex="option_type"
                        filters={[
                            {
                                text: '单选',
                                value: '1'
                            }, {
                                text: '多选',
                                value: '2'
                            }, {
                                text: '判断',
                                value: '3'
                            }, {
                                text: '填空',
                                value: '4'
                            }
                        ]}
                        width={150}
                        render={(text) => {
                            return option_type_text[text] || ''
                        }}
                    />
                    <Column
                        title="审核状态"
                        key="status"
                        align="center"
                        dataIndex="status"
                        width={150}
                        filters={
                            [
                                { text: "待审核", value: "0" },
                                { text: "通过", value: "1" },
                                { text: "待补充", value: "2" },
                                { text: "拒绝", value: "3" }
                            ]
                        }
                        render={(record) => {
                            return <span className="audit-status">
                                {
                                    record === 0 && "待审核"
                                }
                                {
                                    record === 1 && <span className="pass">通过</span>
                                }
                                {
                                    record === 2 && <span className="added">待补充</span>
                                }
                                {
                                    record === 3 && <span className="denied">拒绝</span>
                                }
                            </span>
                        }}
                    />
                    <Column
                        title="发布状态"
                        key="issue"
                        align="center"
                        dataIndex="issue"
                        filterMultiple={false}
                        width={150}
                        filters={
                            [
                                { text: "未发布", value: 1 },
                                { text: "已发布", value: 2 },
                            ]
                        }
                        render={(record) => {
                            return <span className="audit-status">
                                {
                                    record === 1 && <span className="added">未发布</span>
                                }
                                {
                                    record === 2 && <span className="pass">已发布</span>
                                }
                            </span>
                        }}
                    />
                    <Column
                        title="提交者"
                        key="username"
                        align="center"
                        dataIndex="username"
                        width={150}
                        filterDropdown={({ clearFilters }) => {
                            return <div className="table-search">
                                <Input
                                    placeholder="请输入提交者名称"
                                    value={filter.username}
                                    onChange={(e) => {
                                        filter.username = e.target.value;
                                        filter.page = 1;
                                        setFilter({ ...filter })
                                    }}
                                />
                                <Button type="primary" onClick={() => { clearFilters() }}>确定</Button>
                                <Button onClick={() => {
                                    clearFilters();
                                    filter.username = "";
                                    filter.page = 1;
                                    setFilter({ ...filter })
                                }}>取消</Button>
                            </div>
                        }}
                        filterIcon={<SearchOutlined />}
                    />
                    <Column
                        title="提交时间"
                        key="sub_time"
                        align="center"
                        dataIndex="sub_time"
                        width={250}
                    />
                    <Column
                        title="操作"
                        key="operate"
                        align="center"
                        width={userType > 1 ? userIssue ? 260 : 210 : 160}
                        fixed='right'
                        render={(record) => {
                            return <div>
                                <Button
                                    style={{ padding: 0 }}
                                    type="link"
                                    onClick={() => {
                                        window.location.href = "/#/activity/testdetail/0/" + record.id
                                    }}
                                >
                                    详情
                                </Button>
                                <Divider type='vertical' />
                                <Button
                                    style={{ padding: 0 }}
                                    disabled={!record.change}
                                    type="link"
                                    onClick={() => {
                                        window.location.href = "/#/activity/submittest/0/1/" + record.id
                                    }}
                                >
                                    编辑
                                </Button>
                                <Divider type='vertical' />
                                {
                                    userType > 1 ? <>
                                        <Button
                                            style={{ padding: 0 }}
                                            type="link"
                                            onClick={() => {
                                                window.open("/#/activity/submittest/0/2/" + record.id)
                                            }}
                                        >
                                            审核
                                        </Button>
                                        <Divider type='vertical' />
                                    </> : undefined
                                }
                                {
                                    userIssue ? <>
                                        {
                                            record.issue === 1 ?
                                                <Button
                                                    style={{ padding: 0 }}
                                                    disabled={record.status !== 1}
                                                    type="link"
                                                    onClick={() => {
                                                        setComfirmShow({ ...comfirmShow, visible: true, issue: 2 });
                                                        setCheckList([record.id])
                                                    }}
                                                >
                                                    发布
                                                </Button> :
                                                <Button
                                                    style={{ padding: 0 }}
                                                    type="link"
                                                    danger
                                                    onClick={() => {
                                                        setComfirmShow({ ...comfirmShow, visible: true, issue: 1 });
                                                        setCheckList([record.id])
                                                    }}
                                                >
                                                    回收
                                                </Button>
                                        }
                                        <Divider type='vertical' />
                                    </> : undefined
                                }
                                <Button
                                    type="link"
                                    disabled={!record.change}
                                    style={{ padding: 0 }}
                                    danger
                                    onClick={() => {
                                        deleteTip.show = true;
                                        deleteTip.list = [record.id];
                                        setDeteleTip({ ...deleteTip })
                                    }}
                                >删除</Button>
                            </div>
                        }}
                    />
                </Table>
                <Pagination
                    showQuickJumper={true}
                    current={filter.page}
                    pageSize={filter.size}
                    total={initData.allCount}
                    hideOnSinglePage={initData.allCount === 0}
                    pageSizeOptions={['10', '20', '50', '100']}
                    showSizeChanger={true}
                    className="flip-over"
                    style={{ margin: "30px 0" }}
                    onChange={
                        ((page, pageSize) => {
                            let data = { ...filter }
                            data.page = page;
                            data.size = pageSize;
                            setFilter(data)
                        })
                    }
                    onShowSizeChange={(current, size) => {
                        let data = { ...filter }
                        data.page = current;
                        data.size = size;
                        setFilter(data)
                    }}
                />
            </div>
            {
                deleteTip.show &&
                <DeteleBox
                    close={() => {
                        deleteTip.show = false;
                        deleteTip.list = [];
                        setDeteleTip({ ...deleteTip })
                    }}
                    submit={() => resourceDelete(deleteTip.list)}
                />
            }
            <Modal
                className="import-modal"
                title="导入题目"
                visible={visible}
                centered={true}
                closable={false}
                onCancel={() => { setFileList([]); setVisible(false) }}
                footer={<div>
                    <Button onClick={() => { setVisible(false); setFileList([]) }}>取消</Button>
                    <Button type="primary" onClick={onImportTest} loading={uploadLoading}>导入</Button>
                </div>}
            >
                <Row className="line">
                    <Col span={4} className="left-text"><b>*</b>上传题目：</Col>
                    <Col span={20}>
                        <Upload {...uploadProps} className="upload-tool-opt">
                            <Button ghost type="primary" className="upload-btn"><UploadOutlined />选择文件</Button>
                        </Upload>
                    </Col>
                </Row>
                <Row className="line">点击<a download href='/media/test/test.xlsx'>下载</a>导入题目模板</Row>
                <Row>
                    {
                        isUpload && <Progress
                            strokeColor={{
                                from: '#108ee9',
                                to: '#87d068',
                            }}
                            percent={percent}
                            status="active"
                        />
                    }
                </Row>
            </Modal>
            <Comfirm
                boxProperty={comfirmShow}
                onClose={() => {
                    setComfirmShow({ ...comfirmShow, visible: false })
                }}
                onOk={handleIssue}
                ids={checkList}
            />
            <ExportModal
                open={exportShow}
                onClose={() => {
                    setExportShow(false)
                }}
                onOk={handleIssue}
                checkList={[{ label: '题目编号', value: 'number' }, { label: '题目名称', value: 'name' }, { label: '题目分类', value: 'classify__name' }, { label: '题目类型', value: 'option_type' }, { label: '审核状态', value: 'status' }, { label: '发布状态', value: 'issue' }, { label: '提交者', value: 'username' }, { label: '提交时间', value: 'sub_time' }]}
                url='/test/export_test/'
                title='理论题目'
            />
        </div>
    )
}
export default List;